import { SsoIntegration, useSsoIntegrationQuery } from 'graphql-common';

type Args = {
  id: string;
};

export default function useSsoIntegrationQueryHook(args: Args) {
  const { id } = args;

  const query = useSsoIntegrationQuery({
    fetchPolicy: 'network-only',
    skip: !id,
    variables: { id },
  });

  const { refetch, error, loading, data: queryData, previousData } = query;
  const data = queryData || previousData;
  const firstLoading = loading && queryData === undefined;
  const ssoIntegration = data?.data as SsoIntegration;

  return {
    data: ssoIntegration,
    loading,
    error,
    refetch,
    firstLoading,
  };
}
